<template>
    <div>
        <b-modal id="edit-employee" title="Edit Employee Information" scrollable hide-footer>
            <form-resource-edit v-if="employeeResource && !isSaving" :resourceInstance="employeeResource" :fieldSet="formsets.employeeFormSet" ref="employeeEdit" />
            <div v-else>Saving...</div>
            <div class="newUserButtonContainer">
                <b-button @click="closeModal('edit-employee')">Cancel</b-button>
            </div>
        </b-modal>
        <b-button @click="displayForm">Show Selected Employee Detail</b-button>
    </div>
</template>

<script>
import Vue from 'vue'
// components&views
import FormResourceEdit from '../../components/form_resource_edit/FormResourceEdit.vue'
import employeeFormSet from '../../resources/formsets/employee'
// mixins
import modalMixin from '../../mixins/modal'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    props: {
        employeeResource: {
            required: false,
            type: Object,
            default: () => {
                return null
            },
        },
    },
    data() {
        return {
            isSaving: false,
        }
    },
    computed: {
        formsets() {
            return {
                employeeFormSet,
            }
        },
    },
    mixins: [modalMixin, toastMixin],
    components: {
        FormResourceEdit,
    },
    methods: {
        displayForm() {
            this.showModal('edit-employee')
        },

        async saveChanges() {
            try {
                this.isSaving = true
                const result = await this.employeeResource.save()
                if (result.response.status === 200 || result.response.status === 201) {
                    this.createToast('b-toaster-top-center', 'success', true, 'Saved', '')
                    this.closeModal('edit-employee')
                }
            } catch (error) {
                // console.log(error)
                this.createToast('b-toaster-top-center', 'danger', true, 'Information Saved Error', '')
                throw error
            }
            this.isSaving = false
        },
    },
})
</script>

<style scoped>
.newUserButtonContainer {
    display: flex;
    justify-content: space-between;
}
</style>
